import {
  getSingleChoiceQueryParameters,
  getMultipleChoiceQueryParameters,
} from "./utils/parameters"
import { SearchParameters } from "./interfaces/SearchParameters.interface"

const rapportHeaders = {
  "X-client": "NVDB-Rapporter-Frontend-Gammel",
}

// FETCHING CORRECT API URL
// COULD BE IMPROVED
const myHost = typeof window !== "undefined" ? window.location.href : ""
function contextualPath(): string {
  if (myHost.includes("localhost")) {
    return "http://localhost:8080/rapporter" //"https://nvdbrapportapi.atlas.vegvesen.no/rapporter"
  } else if (myHost.includes("nvdb-veglister.utv.atlas.vegvesen.no")) {
    return "https://nvdbrapportapi.utv.atlas.vegvesen.no/rapporter"
  } else if (myHost.includes("nvdb-veglister.test.atlas.vegvesen.no")) {
    return "https://nvdbrapportapi.test.atlas.vegvesen.no/rapporter"
  } else if (myHost.includes("nvdb-veglister.atlas.vegvesen.no")) {
    return "https://nvdbrapportapi.atlas.vegvesen.no/rapporter"
  }
  return "http://localhost:8080/rapporter"
}

export const apiPath: string = contextualPath()

export function fetchBruksklasser() {
  return fetch(`${apiPath}/bruksklasser`, {
    headers: rapportHeaders,
  })
}

export function fetchFylkerOgKommuner() {
  return fetch(`${apiPath}/omraader`, {
    headers: rapportHeaders,
  })
}

export const apiURLWithParams = (params: SearchParameters) => {
  const url = new URL(apiPath + "/veglister/" + params.bruksklasse)
  const paramsSingleChoices = getSingleChoiceQueryParameters(params)
  const paramsMultipleChoices = getMultipleChoiceQueryParameters(params)
  paramsSingleChoices.forEach((value, key) => {
    url.searchParams.append(key, value)
  })
  paramsMultipleChoices.forEach((value, key) => {
    value.split(",").forEach(singleParam => {
      url.searchParams.append(key, singleParam)
    })
  })
  return url.toString()
}
